import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ChangeLanguageService } from 'app/core/util/change-language.service';
import { DataUtils } from 'app/core/util/data-util.service';
import { CbicContentMstService } from 'app/entities/cbic-content-mst/service/cbic-content-mst.service';
import { CbicContentTypeMstService } from 'app/entities/cbic-content-type-mst/service/cbic-content-type-mst.service';
import { CbicDocMstService } from 'app/entities/cbic-doc-mst/service/cbic-doc-mst.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SessionStorageService } from 'ngx-webstorage';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';

@Component({
  selector: 'cbic-chairman-desk',
  templateUrl: './chairman-desk.component.html',
  styleUrls: ['./chairman-desk.component.scss'] 
})
export class ChairmanDeskComponent implements OnInit {
  getFilePath: any;
  chairmanProfile? : ICbicContentMst|null;
  pastChairmenSectionContent?:SafeHtml|null;
  getFileImage: any;
  usedLanguage: any;
  contentTypeId: any;
  sectionContentDiv: any;
  sectionHtmlPath: any;
  sectionImagePath: any;
  sectionContentDivImage: any;
  color: any;
  constructor(private sessionStorageService: SessionStorageService, private contentMstService: CbicContentMstService, private cbicContentTypeMstService: CbicContentTypeMstService, private changeLnService: ChangeLanguageService, private cbicDocMstService: CbicDocMstService
    , private http: HttpClient, private dataUtils: DataUtils, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.usedLanguage = this.changeLnService.getLanguage();
    this.color = this.sessionStorageService.retrieve('colr');
    //alert(this.color);
    this.getContentId();
  }
  getContentId(): void {
    this.cbicContentTypeMstService.getContentId('Chairman-Desk').subscribe(
      (fullBody) => {

        this.contentTypeId = fullBody.body?.id;

        this.findFilePath(this.contentTypeId);

      }
    )
  }
  findFilePath(contentTypeId: any): void {
    this.contentMstService.findFilePath(Number(contentTypeId)).subscribe(
      (fullBody: HttpResponse<ICbicContentMst[]>) => {
        if(!fullBody.body){
          return;
        } 

        this.chairmanProfile = fullBody.body[0];
        const pastChairmen = fullBody.body[1];
        
        this.getFileImage = this.chairmanProfile.path;

        let chairmanProfilePath = this.chairmanProfile.infoEn;
        if (this.usedLanguage === "hi") {
          chairmanProfilePath = this.chairmanProfile.infoHi;
        }

        this.fetchDataForImage(this.getFileImage);
        this.fetchDataForPdfHtml(this.getFilePath).then(html=>{
          this.sectionContentDiv = html;
        });
        
        this.fetchDataForPdfHtml(chairmanProfilePath).then(html=>{
          this.sectionContentDiv = html;
        });

        let pastChairmenFile = pastChairmen.infoEn;
        if (this.usedLanguage === "hi") {
          pastChairmenFile = pastChairmen.infoHi;
        }
        this.fetchDataForPdfHtml(pastChairmenFile).then(html=>{
          this.pastChairmenSectionContent = html;
        });
      });
  }

  async fetchDataForPdfHtml(sectionHtmlPath: string|null|undefined): Promise<SafeHtml> {
    return new Promise((resolve, reject)=>{
      const arr = sectionHtmlPath!.split('.');
      if ((arr[arr.length - 1] !== 'html')) {
        reject("only HTML files are allowed");
      }
      this.http
        .get(`content/html/${sectionHtmlPath}`,
          { responseType: 'text' })
        .subscribe(data => {
          resolve(this.sanitizer.bypassSecurityTrustHtml(data));
        });
    });
  }

  fetchDataForImage(sectionImagePath: string): void {
    this.sectionImagePath = this.getFileImage;

    this.http.get('content/image/' + sectionImagePath,
      { responseType: 'text' })
      .subscribe(res => {
        const json = JSON.parse(res);
        const fileURL = 'data:application/image;base64,' + String(json.data);

        this.sectionContentDivImage = this.sanitizer.bypassSecurityTrustHtml(
          "<img title='Chairman' class='img-fluid border_radius_1rem' src='" + fileURL + "' type='application/image' >" +

          "</img>");


      }
      );
  }
}
